// Growth math for a By Channel cell. Growth reads on the full year: on a
// quarterly revision the channel's sold months (`actual`) count on top of
// the remaining-months plan; a plain plan has no actual, so it is 0 there.

// Growth % as the input shows it ("" when there is nothing to compare).
export function deriveGrowth({ past, plan, actual = 0 }: { past: number; plan: number; actual?: number }): string {
  if (past <= 0 || (plan === 0 && actual === 0)) return ''
  return String(Number((((actual + plan - past) / past) * 100).toFixed(2)))
}

// The remaining-months plan a typed growth % stands for: the full-year
// number minus the sold months, never below 0.
export function planFromGrowth({ past, pct, actual = 0 }: { past: number; pct: number; actual?: number }): number {
  return Math.max(0, Math.round(past * (1 + pct / 100) - actual))
}
